module.exports = __webpack_public_path__ + "img/1412067291.4d995f42.jpg";